import { useState, useEffect } from "react";
import { supabase } from "./supabase";
import { findPackageForTreatment } from "./packageMatch";

const C = {
  bg:"#f8f5f0", surface:"#ffffff", card:"#ffffff", border:"#e8e4df",
  borderGold:"rgba(180,140,60,0.3)", goldBg:"rgba(180,140,60,0.08)",
  gold:"#b48c3c", goldD:"#8a6f2e",
  green:"#2e8b57", greenL:"rgba(46,139,87,0.12)",
  red:"#c0392b", redL:"rgba(192,57,43,0.10)",
  blue:"#2563eb", blueL:"rgba(37,99,235,0.10)",
  text:"#1a1a2e", muted:"#6b7280", dim:"#9ca3af", light:"#f3f4f6",
};
const F = "'Montserrat',sans-serif";
const S = "'Playfair Display','Cormorant Garamond',Georgia,serif";

const TREATS = ["Botox","Lip Filler","Cheek Filler","Chemical Peel","Laser Hair Removal","RF Microneedling","HydraFacial","PRP Hair","Dermaplaning","Ultherapy","Kybella","IPL Photofacial","Sculptra","Juvederm","IV Therapy","CO2 Laser"];

const inp = {width:"100%",padding:"10px 12px",background:C.light,border:"1px solid "+C.border,borderRadius:8,fontSize:13,color:C.text,fontFamily:F,outline:"none",boxSizing:"border-box"};

export function PackagesCatalog() {
  const [packages, setPackages] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editPkg, setEditPkg] = useState(null);
  const [form, setForm] = useState({name:"",description:"",treatment:"Botox",sessions_total:5,price:0,value:0,validity_days:365,active:true});
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);

  const load = async () => {
    const { data } = await supabase.from("packages").select("*").order("created_at", { ascending: false });
    setPackages(data || []);
    setLoading(false);
  };

  const openNew = () => {
    setEditPkg(null);
    setForm({name:"",description:"",treatment:"Botox",sessions_total:5,price:0,value:0,validity_days:365,active:true});
    setShowForm(true);
  };

  const openEdit = (p) => {
    setEditPkg(p);
    setForm({...p});
    setShowForm(true);
  };

  const save = async () => {
    if (!form.name || !form.treatment || !form.sessions_total || !form.price) return;
    if (editPkg) {
      await supabase.from("packages").update(form).eq("id", editPkg.id);
    } else {
      await supabase.from("packages").insert([form]);
    }
    setShowForm(false);
    load();
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this package? Existing patient packages will not be affected.")) return;
    await supabase.from("packages").delete().eq("id", id);
    load();
  };

  const savings = (p) => {
    if (!p.value || p.value <= p.price) return null;
    return Math.round(((p.value - p.price) / p.value) * 100);
  };

  return (
    <div>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20}}>
        <div>
          <div style={{fontSize:20,fontWeight:800,color:C.gold,fontFamily:S}}>Packages Catalog</div>
          <div style={{fontSize:12,color:C.muted,marginTop:2}}>Create treatment bundles to sell to clients</div>
        </div>
        <button onClick={openNew} style={{padding:"10px 18px",background:"linear-gradient(135deg,"+C.gold+","+C.goldD+")",color:"#fff",border:"none",borderRadius:8,fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:F}}>+ New Package</button>
      </div>

      {loading && <div style={{padding:40,textAlign:"center",color:C.muted}}>Loading...</div>}

      {!loading && packages.length === 0 && (
        <div style={{padding:60,textAlign:"center",background:C.light,borderRadius:12,border:"1px dashed "+C.border}}>
          <div style={{fontSize:40,marginBottom:10,opacity:0.3}}>📦</div>
          <div style={{fontSize:14,fontWeight:700,color:C.text,marginBottom:6}}>No packages yet</div>
          <div style={{fontSize:12,color:C.muted,marginBottom:14}}>Create your first package bundle!</div>
          <button onClick={openNew} style={{padding:"9px 16px",background:"linear-gradient(135deg,"+C.gold+","+C.goldD+")",color:"#fff",border:"none",borderRadius:8,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:F}}>Create Package</button>
        </div>
      )}

      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))",gap:14}}>
        {packages.map(p => {
          const save = savings(p);
          return (
            <div key={p.id} style={{background:C.card,border:"1px solid "+C.border,borderRadius:12,padding:16,position:"relative",opacity:p.active?1:0.5}}>
              {save && <div style={{position:"absolute",top:10,right:10,background:C.green,color:"#fff",padding:"3px 9px",borderRadius:12,fontSize:10,fontWeight:800}}>SAVE {save}%</div>}
              {!p.active && <div style={{position:"absolute",top:10,right:10,background:C.muted,color:"#fff",padding:"3px 9px",borderRadius:12,fontSize:10,fontWeight:800}}>INACTIVE</div>}
              <div style={{fontSize:11,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:6}}>{p.treatment}</div>
              <div style={{fontSize:16,fontWeight:800,color:C.text,fontFamily:S,marginBottom:4}}>{p.name}</div>
              {p.description && <div style={{fontSize:11,color:C.muted,marginBottom:10,lineHeight:1.4}}>{p.description}</div>}
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"baseline",paddingTop:10,borderTop:"1px solid "+C.border,marginTop:10}}>
                <div>
                  <div style={{fontSize:20,fontWeight:800,color:C.gold}}>${p.price}</div>
                  {p.value && p.value > p.price && <div style={{fontSize:11,color:C.muted,textDecoration:"line-through"}}>${p.value}</div>}
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{fontSize:13,fontWeight:700,color:C.text}}>{p.sessions_total} sessions</div>
                  <div style={{fontSize:10,color:C.muted}}>Valid {p.validity_days} days</div>
                </div>
              </div>
              <div style={{display:"flex",gap:6,marginTop:12}}>
                <button onClick={()=>openEdit(p)} style={{flex:1,padding:"7px",background:C.goldBg,color:C.gold,border:"1px solid "+C.borderGold,borderRadius:7,fontSize:11,fontWeight:600,cursor:"pointer",fontFamily:F}}>Edit</button>
                <button onClick={()=>remove(p.id)} style={{flex:1,padding:"7px",background:C.redL,color:C.red,border:"1px solid "+C.red+"30",borderRadius:7,fontSize:11,fontWeight:600,cursor:"pointer",fontFamily:F}}>Delete</button>
              </div>
            </div>
          );
        })}
      </div>

      {showForm && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:1500,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div style={{background:"#fff",borderRadius:14,width:"100%",maxWidth:480,padding:24,maxHeight:"90vh",overflowY:"auto"}}>
            <div style={{fontSize:18,fontWeight:800,color:C.gold,fontFamily:S,marginBottom:16}}>{editPkg?"Edit Package":"New Package"}</div>
            <div style={{display:"flex",flexDirection:"column",gap:12,marginBottom:16}}>
              <div>
                <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>Name *</label>
                <input value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder="Botox VIP 5-Pack" style={inp} />
              </div>
              <div>
                <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>Description</label>
                <input value={form.description} onChange={e=>setForm({...form,description:e.target.value})} placeholder="5 Botox treatments at 15% off" style={inp} />
              </div>
              <div>
                <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>Treatment *</label>
                <select value={form.treatment} onChange={e=>setForm({...form,treatment:e.target.value})} style={inp}>
                  {TREATS.map(t => <option key={t}>{t}</option>)}
                </select>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                <div>
                  <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>Sessions *</label>
                  <input type="number" value={form.sessions_total} onChange={e=>setForm({...form,sessions_total:+e.target.value})} style={inp} />
                </div>
                <div>
                  <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>Validity (days)</label>
                  <input type="number" value={form.validity_days} onChange={e=>setForm({...form,validity_days:+e.target.value})} style={inp} />
                </div>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                <div>
                  <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>Package Price *</label>
                  <input type="number" value={form.price} onChange={e=>setForm({...form,price:+e.target.value})} style={inp} />
                </div>
                <div>
                  <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>Regular Value</label>
                  <input type="number" value={form.value} onChange={e=>setForm({...form,value:+e.target.value})} placeholder="Optional" style={inp} />
                </div>
              </div>
              <label style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer"}}>
                <input type="checkbox" checked={form.active} onChange={e=>setForm({...form,active:e.target.checked})} style={{accentColor:C.gold}} />
                <span style={{fontSize:12,color:C.text,fontWeight:600}}>Active (visible for sale)</span>
              </label>
            </div>
            <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
              <button onClick={()=>setShowForm(false)} style={{padding:"9px 16px",background:C.light,color:C.muted,border:"1px solid "+C.border,borderRadius:8,fontSize:12,cursor:"pointer",fontFamily:F}}>Cancel</button>
              <button onClick={save} style={{padding:"9px 16px",background:"linear-gradient(135deg,"+C.gold+","+C.goldD+")",color:"#fff",border:"none",borderRadius:8,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:F}}>{editPkg?"Save":"Create"}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════
// ClientWallet — modeled after AestheticRecord's wallet panel.
//   Sections:
//     1. Wallet Overview (total $ value of all active items)
//     2. Items table (per-item: units + $ balance + Add/Edit/Remove)
//     3. Wallet Log/Usage (full audit trail — date / employee / desc / amount)
//     4. Download Excel (CSV export of the log)
//
//   Key concept (matches AR): every wallet item has BOTH a unit count
//   AND a $ balance. When staff "deducts" a session, both fall by one
//   unit + unit_value dollars. Credit items (Xperience / Aspire) have
//   no units — just $.
// ════════════════════════════════════════════════════════════════════
export function ClientWallet({ client, onClose }) {
  const [wallet, setWallet] = useState([]);
  const [walletLog, setWalletLog] = useState([]);
  const [packages, setPackages] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const [editItem, setEditItem] = useState(null);  // {id, item_name, units, dollars, ...}
  const [addMode, setAddMode] = useState("catalog");  // "catalog" | "custom" | "credit"
  const [services, setServices] = useState([]);
  const [selectedPkg, setSelectedPkg] = useState("");   // "pkg:<id>" or "svc:<id>"
  const [catalogUnits, setCatalogUnits] = useState(1);  // units when a service is picked
  const [customForm, setCustomForm] = useState({ item_name: "", units: 1, unit_value: 0, total_paid: 0, treatment: "" });
  const [creditForm, setCreditForm] = useState({ item_name: "Xperience Credit", dollar_balance: 0 });
  const [showAdjust, setShowAdjust] = useState(false);
  const [adjustTarget, setAdjustTarget] = useState("");

  useEffect(() => {
    if (!client?.id) return;
    loadAll();
    const ch = supabase.channel("wallet-" + client.id)
      .on("postgres_changes", { event: "*", schema: "public", table: "patient_packages", filter: "client_id=eq." + client.id }, () => loadAll())
      .on("postgres_changes", { event: "*", schema: "public", table: "wallet_log", filter: "client_id=eq." + client.id }, () => loadAll())
      .subscribe();
    return () => { supabase.removeChannel(ch); };
  }, [client?.id]);

  const loadAll = async () => {
    const [{ data: items }, { data: log }, { data: pkgs }, { data: svcs }] = await Promise.all([
      supabase.from("patient_packages").select("*").eq("client_id", client.id).order("purchase_date", { ascending: false }),
      supabase.from("wallet_log").select("*").eq("client_id", client.id).order("created_at", { ascending: false }).limit(200),
      supabase.from("packages").select("*").eq("active", true),
      supabase.from("services").select("id,name,price,category,duration_minutes").eq("active", true).order("category").order("name"),
    ]);
    // Normalize: compute virtual sessions_remaining + alias old field names
    // so the UI code can keep using its readable names. The DB uses
    // total_sessions/used_sessions/treatment_type/purchase_date/expiry_date.
    const normalized = (items || []).map(it => ({
      ...it,
      sessions_total: it.total_sessions,
      sessions_used: it.used_sessions,
      sessions_remaining: Math.max(0, (it.total_sessions || 0) - (it.used_sessions || 0)),
      treatment: it.treatment_type,
      purchased_at: it.purchase_date,
      expires_at: it.expiry_date,
    }));
    setWallet(normalized);
    setWalletLog(log || []);
    setPackages(pkgs || []);
    // All bookable services (treatments) — exclude retail products from the wallet picker.
    setServices((svcs || []).filter(s => !/^retail/i.test(s.category || "")));
  };

  // Append a row to wallet_log. Best-effort — never throw on logging fail.
  const logEvent = async ({ patient_package_id, action_type, item_name, description, units_delta = 0, dollar_delta = 0, units_after = null, dollar_after = null, appointment_id = null }) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      let employee_name = "Staff";
      if (user?.id) {
        const { data: p } = await supabase.from("profiles").select("full_name,email").eq("id", user.id).maybeSingle();
        employee_name = p?.full_name || p?.email || "Staff";
      }
      await supabase.from("wallet_log").insert([{
        client_id: client.id,
        client_name: client.name,
        patient_package_id,
        appointment_id,
        action_type,
        item_name,
        description,
        units_delta,
        dollar_delta,
        units_after,
        dollar_after,
        employee_id: user?.id || null,
        employee_name,
      }]);
    } catch (e) { console.warn("wallet_log insert failed:", e); }
  };

  // ── ADD from catalog ───────────────────────────────────────────────
  const addFromCatalog = async () => {
    if (!selectedPkg) return;
    const [kind, idStr] = String(selectedPkg).includes(":") ? selectedPkg.split(":") : ["pkg", selectedPkg];
    const id = +idStr;

    // Resolve to a common shape whether a Package or a Service was picked.
    let name, treatment, units, totalPaid, validityDays;
    if (kind === "svc") {
      const svc = services.find(s => s.id === id);
      if (!svc) return;
      name = svc.name;
      treatment = svc.name;
      units = Math.max(1, +catalogUnits || 1);
      totalPaid = +(Number(svc.price || 0) * units).toFixed(2);
      validityDays = 365;
    } else {
      const pkg = packages.find(p => p.id === id);
      if (!pkg) return;
      name = pkg.name;
      treatment = pkg.treatment;
      units = pkg.sessions_total;
      totalPaid = pkg.price;
      validityDays = pkg.validity_days || 365;
    }
    const unitValue = units > 0 ? +(totalPaid / units).toFixed(2) : 0;
    const expires = new Date();
    expires.setDate(expires.getDate() + validityDays);
    const { data: inserted, error: insErr } = await supabase.from("patient_packages").insert([{
      client_id: client.id,
      client_name: client.name,
      package_name: name,
      treatment_type: treatment,
      total_sessions: units,
      used_sessions: 0,
      price_paid: totalPaid,
      dollar_balance: totalPaid,
      unit_value: unitValue,
      is_credit: false,
      expiry_date: expires.toISOString(),
      status: "active",
    }]).select("id").single();
    if (insErr) { alert("Failed to add to wallet:\n" + insErr.message); return; }
    await logEvent({
      patient_package_id: inserted?.id,
      action_type: "add",
      item_name: name,
      description: `Added ${kind === "svc" ? "Service" : "Product"} - ${name} - ${units} unit(s)`,
      units_delta: units,
      dollar_delta: totalPaid,
      units_after: units,
      dollar_after: totalPaid,
    });
    closeAdd();
    await loadAll();
  };

  // ── ADD custom (one-off item not in catalog) ──────────────────────
  const addCustom = async () => {
    const { item_name, units, unit_value, total_paid, treatment } = customForm;
    if (!item_name || units < 1) return;
    const totalPaid = total_paid || (units * unit_value);
    const uv = unit_value || +(totalPaid / units).toFixed(2);
    const expires = new Date();
    expires.setDate(expires.getDate() + 365);
    const { data: inserted, error: insErr } = await supabase.from("patient_packages").insert([{
      client_id: client.id,
      client_name: client.name,
      package_name: item_name,
      treatment_type: treatment || item_name,
      total_sessions: units,
      used_sessions: 0,
      price_paid: totalPaid,
      dollar_balance: totalPaid,
      unit_value: uv,
      is_credit: false,
      expiry_date: expires.toISOString(),
      status: "active",
    }]).select("id").single();
    if (insErr) { alert("Failed to add to wallet:\n" + insErr.message); return; }
    await logEvent({
      patient_package_id: inserted?.id,
      action_type: "add",
      item_name,
      description: `Added Product - ${item_name} - ${units} unit(s)`,
      units_delta: units,
      dollar_delta: totalPaid,
      units_after: units,
      dollar_after: totalPaid,
    });
    closeAdd();
    await loadAll();
  };

  // ── ADD credit-program (Xperience / Aspire / generic $-only) ─────
  const addCredit = async () => {
    const { item_name, dollar_balance } = creditForm;
    if (!item_name || !dollar_balance) return;
    const { data: inserted, error: insErr } = await supabase.from("patient_packages").insert([{
      client_id: client.id,
      client_name: client.name,
      package_name: item_name,
      treatment_type: item_name,
      total_sessions: 0,
      used_sessions: 0,
      price_paid: dollar_balance,
      dollar_balance,
      unit_value: 0,
      is_credit: true,
      status: "active",
    }]).select("id").single();
    if (insErr) { alert("Failed to add credit:\n" + insErr.message); return; }
    await logEvent({
      patient_package_id: inserted?.id,
      action_type: "credit",
      item_name,
      description: `Added Credit - ${item_name} - $${dollar_balance.toFixed(2)}`,
      units_delta: 0,
      dollar_delta: dollar_balance,
      units_after: 0,
      dollar_after: dollar_balance,
    });
    closeAdd();
    await loadAll();
  };

  // ── UPDATE total wallet value ───────────────────────────────────────
  // Sets the wallet's total $ value to a target by adjusting a dedicated
  // "Wallet Credit" item (created if missing). Packages keep their own value —
  // the credit item absorbs the difference. Fully logged. Can't drop the total
  // below the value already locked in real packages (edit those individually).
  const adjustWalletValue = async () => {
    const target = +adjustTarget;
    if (isNaN(target) || target < 0) return;
    // Everything except the adjustment row.
    const base = wallet
      .filter(w => w.status === "active" && w.package_name !== ADJ_NAME && (w.is_credit ? (w.dollar_balance > 0) : (w.sessions_remaining > 0 || w.dollar_balance > 0)))
      .reduce((s, w) => s + Number(w.dollar_balance || 0), 0);
    const needed = +(target - base).toFixed(2);   // may be negative
    const prev = adjAmount;
    const delta = +(needed - prev).toFixed(2);
    const tiny = Math.abs(needed) < 0.005;
    try {
      if (adjItem) {
        if (tiny) await supabase.from("patient_packages").delete().eq("id", adjItem.id);
        else await supabase.from("patient_packages").update({ dollar_balance: needed, price_paid: needed > 0 ? needed : 0, status: "active" }).eq("id", adjItem.id);
      } else if (!tiny) {
        const expires = new Date(); expires.setDate(expires.getDate() + 365);
        await supabase.from("patient_packages").insert([{
          client_id: client.id, client_name: client.name,
          package_name: ADJ_NAME, treatment_type: ADJ_NAME,
          total_sessions: 0, used_sessions: 0, price_paid: needed > 0 ? needed : 0,
          dollar_balance: needed, unit_value: 0, is_credit: true,
          expiry_date: expires.toISOString(), status: "active",
        }]);
      }
      await logEvent({
        patient_package_id: adjItem?.id || null,
        action_type: delta >= 0 ? "credit" : "deduct",
        item_name: ADJ_NAME,
        description: `Wallet value set to $${target.toFixed(2)} (${delta >= 0 ? "+" : "−"}$${Math.abs(delta).toFixed(2)})`,
        dollar_delta: delta,
        dollar_after: needed,
      });
    } catch (e) { alert("Failed to update wallet value:\n" + (e.message || e)); return; }
    setShowAdjust(false);
    await loadAll();
  };

  const closeAdd = () => {
    setShowAdd(false);
    setSelectedPkg("");
    setCatalogUnits(1);
    setCustomForm({ item_name: "", units: 1, unit_value: 0, total_paid: 0, treatment: "" });
    setCreditForm({ item_name: "Xperience Credit", dollar_balance: 0 });
    setAddMode("catalog");
  };

  // When staff change the unit count on a wallet item, the dollar value follows
  // automatically (units × unit_value) — e.g. 4 IV @ $250 = $1,000; drop to 3 →
  // $750 — so the remaining credit is always correct without re-doing the math.
  // Credit items (unit_value 0) keep their dollar balance edited directly.
  const setEditUnits = (u) => {
    const units = Math.max(0, Math.floor(+u || 0));
    setEditItem(prev => {
      if (!prev) return prev;
      const uv = +(prev.unit_value || 0);
      return { ...prev, sessions_remaining: units, ...(uv > 0 ? { dollar_balance: +(units * uv).toFixed(2) } : {}) };
    });
  };

  // ── EDIT existing item (adjust units / $ balance) ─────────────────
  const saveEdit = async () => {
    if (!editItem) return;
    const oldItem = wallet.find(w => w.id === editItem.id);
    if (!oldItem) return;
    const newUnits = Math.max(0, +editItem.sessions_remaining);
    const newDollar = Math.max(0, +editItem.dollar_balance);
    // sessions_remaining is virtual — adjust used_sessions to back into it.
    const totalSessions = oldItem.total_sessions || oldItem.sessions_total || 0;
    const newUsed = Math.max(0, totalSessions - newUnits);
    const newStatus = newUnits === 0 && !oldItem.is_credit ? "completed" : "active";
    await supabase.from("patient_packages").update({
      used_sessions: newUsed,
      dollar_balance: newDollar,
      unit_value: editItem.unit_value || oldItem.unit_value,
      status: newStatus,
    }).eq("id", editItem.id);
    await logEvent({
      patient_package_id: editItem.id,
      action_type: "edit",
      item_name: oldItem.package_name || oldItem.treatment,
      description: `Edited ${oldItem.package_name || oldItem.treatment} - now ${newUnits} unit(s) / $${newDollar.toFixed(2)}`,
      units_delta: newUnits - oldItem.sessions_remaining,
      dollar_delta: newDollar - (oldItem.dollar_balance || 0),
      units_after: newUnits,
      dollar_after: newDollar,
    });
    setEditItem(null);
    await loadAll();
  };

  // ── REMOVE item entirely (rare — usually for mistaken adds) ───────
  const removeItem = async (item) => {
    const label = item.package_name || item.treatment_type || item.treatment || "item";
    if (!window.confirm(`Remove ${label} from the wallet entirely? This cannot be undone.`)) return;
    await supabase.from("patient_packages").delete().eq("id", item.id);
    await logEvent({
      patient_package_id: null,  // row is gone
      action_type: "remove",
      item_name: label,
      description: `Removed Product - ${label}`,
      units_delta: -(item.sessions_remaining || 0),
      dollar_delta: -(item.dollar_balance || 0),
      units_after: 0,
      dollar_after: 0,
    });
    await loadAll();
  };

  // ── Excel/CSV download (no external library — plain CSV) ─────────
  const downloadCsv = () => {
    const rows = [
      ["Date", "Employee", "Description", "Units", "Amount"],
      ...walletLog.map(r => [
        new Date(r.created_at).toLocaleString("en-US", { month: "2-digit", day: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit", hour12: true }),
        r.employee_name || "",
        (r.description || "").replace(/"/g, '""'),
        r.units_delta || 0,
        r.dollar_delta ? `$${Number(r.dollar_delta).toFixed(2)}` : "",
      ])
    ];
    const csv = rows.map(row => row.map(cell => `"${cell}"`).join(",")).join("\n");
    const blob = new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `wallet-log-${client.name.replace(/\s+/g, "-")}-${new Date().toISOString().slice(0,10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  // ── Aggregates ──
  // A dedicated "Wallet Adjustment" row lets staff set the TOTAL to any value
  // (incl. lower than the sum of items) and have it stick. It can be negative
  // and is always counted in the total.
  const ADJ_NAME = "Wallet Adjustment";
  const adjItem = wallet.find(w => w.status === "active" && w.package_name === ADJ_NAME);
  const adjAmount = adjItem ? Number(adjItem.dollar_balance || 0) : 0;
  const activeItems = wallet.filter(w => w.status === "active" && w.package_name !== ADJ_NAME && (w.is_credit ? (w.dollar_balance > 0) : (w.sessions_remaining > 0 || w.dollar_balance > 0)));
  const baseTotal = activeItems.reduce((sum, w) => sum + Number(w.dollar_balance || 0), 0);
  const totalWalletValue = +(baseTotal + adjAmount).toFixed(2);

  return (
    <div style={{padding:24,background:C.surface,borderRadius:14,border:"1px solid "+C.border,maxWidth:"100%"}}>

      {/* ── Header ── */}
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:18}}>
        <div style={{fontSize:18,fontWeight:800,color:C.text,fontFamily:S}}>Wallet — {client.name}</div>
        {onClose && <button onClick={onClose} style={{background:C.light,border:"none",borderRadius:7,padding:"5px 12px",cursor:"pointer",fontSize:18,color:C.muted}}>×</button>}
      </div>

      {/* ── Wallet Overview ── */}
      <div style={{padding:"18px 22px",background:"linear-gradient(135deg,"+C.goldBg+",rgba(180,140,60,0.02))",border:"1px solid "+C.borderGold,borderRadius:12,marginBottom:18,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div>
          <div style={{fontSize:13,color:C.muted,fontWeight:600,marginBottom:3}}>Wallet Overview</div>
          <div style={{fontSize:10,color:C.dim,textTransform:"uppercase",letterSpacing:"0.06em"}}>{activeItems.length} active item{activeItems.length === 1 ? "" : "s"}</div>
        </div>
        <div style={{textAlign:"right"}}>
          <div style={{fontSize:26,fontWeight:800,color:C.gold,fontFamily:S}}>${totalWalletValue.toFixed(2)}</div>
          <div style={{fontSize:9,color:C.muted,textTransform:"uppercase",letterSpacing:"0.08em",fontWeight:700}}>Total Wallet Value</div>
          {adjAmount !== 0 && <div style={{fontSize:10,color:C.muted,marginTop:2}}>incl. {adjAmount > 0 ? "+" : "−"}${Math.abs(adjAmount).toFixed(2)} adjustment</div>}
          <button onClick={()=>{ setAdjustTarget(totalWalletValue.toFixed(2)); setShowAdjust(true); }} style={{marginTop:7,padding:"4px 11px",background:"transparent",color:C.goldD,border:"1px solid "+C.borderGold,borderRadius:7,fontSize:10.5,fontWeight:700,cursor:"pointer",fontFamily:F}}>✎ Edit Value</button>
        </div>
      </div>

      {/* ── Update Wallet Value Modal ── */}
      {showAdjust && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div style={{background:"#fff",borderRadius:14,width:"100%",maxWidth:400,padding:24}}>
            <div style={{fontSize:16,fontWeight:800,color:C.gold,fontFamily:S,marginBottom:5}}>Update Wallet Value</div>
            <div style={{fontSize:11,color:C.muted,marginBottom:14}}>Set the total wallet value for {client.name}. Adjusts store credit — packages keep their own value (edit those individually).</div>
            <div style={{display:"flex",justifyContent:"space-between",fontSize:12,color:C.muted,marginBottom:10,padding:"8px 12px",background:C.light,borderRadius:8}}>
              <span>Current total</span><span style={{fontWeight:800,color:C.text}}>${totalWalletValue.toFixed(2)}</span>
            </div>
            <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>New Total Value ($)</label>
            <input type="number" step="0.01" min={0} value={adjustTarget} onChange={e=>setAdjustTarget(e.target.value)} autoFocus style={inp}/>
            <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:16}}>
              <button onClick={()=>setShowAdjust(false)} style={{padding:"9px 16px",background:C.light,color:C.muted,border:"1px solid "+C.border,borderRadius:7,fontSize:12,cursor:"pointer",fontFamily:F}}>Cancel</button>
              <button onClick={adjustWalletValue} disabled={adjustTarget===""||isNaN(+adjustTarget)} style={{padding:"9px 18px",background:(adjustTarget===""||isNaN(+adjustTarget))?C.light:"linear-gradient(135deg,"+C.gold+","+C.goldD+")",color:(adjustTarget===""||isNaN(+adjustTarget))?C.muted:"#fff",border:"none",borderRadius:7,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:F}}>Update</button>
            </div>
          </div>
        </div>
      )}

      {/* ── Items table ── */}
      <div style={{marginBottom:24}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
          <div style={{fontSize:13,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.06em"}}>Items</div>
          <button onClick={()=>setShowAdd(true)} style={{padding:"8px 16px",background:"linear-gradient(135deg,"+C.gold+","+C.goldD+")",color:"#fff",border:"none",borderRadius:8,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:F}}>+ Add Item</button>
        </div>
        {activeItems.length === 0 ? (
          <div style={{padding:30,textAlign:"center",background:C.light,borderRadius:10,color:C.muted,fontSize:12,border:"1px dashed "+C.border}}>No items in wallet. Click <strong>+ Add Item</strong>.</div>
        ) : (
          <div style={{border:"1px solid "+C.border,borderRadius:10,overflow:"hidden"}}>
            <div style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1.2fr",padding:"10px 14px",background:C.light,fontSize:10,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:"0.06em"}}>
              <div>Item</div><div>Balance Units</div><div>$ Balance</div><div>Action</div>
            </div>
            {activeItems.map(item => (
              <div key={item.id} style={{display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1.2fr",padding:"12px 14px",borderTop:"1px solid "+C.border,alignItems:"center",fontSize:13}}>
                <div>
                  <div style={{fontWeight:700,color:C.text}}>{item.package_name || item.treatment}</div>
                  {item.is_credit && <div style={{fontSize:9,color:C.gold,fontWeight:700,marginTop:2}}>CREDIT PROGRAM</div>}
                  {!item.is_credit && item.expires_at && <div style={{fontSize:9,color:C.muted,marginTop:2}}>Expires {new Date(item.expires_at).toLocaleDateString()}</div>}
                </div>
                <div style={{color:item.is_credit?C.dim:C.text,fontWeight:600}}>{item.is_credit ? "—" : item.sessions_remaining}</div>
                <div style={{color:C.text,fontWeight:700}}>${Number(item.dollar_balance || 0).toFixed(2)}</div>
                <div style={{display:"flex",gap:8}}>
                  <button onClick={()=>setEditItem({...item})} style={{padding:"5px 10px",background:"transparent",color:C.blue,border:"none",fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:F,textDecoration:"underline"}}>Edit</button>
                  <button onClick={()=>removeItem(item)} style={{padding:"5px 10px",background:"transparent",color:C.red,border:"none",fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:F,textDecoration:"underline"}}>Remove</button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ── Wallet Log/Usage ── */}
      <div>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
          <div style={{fontSize:13,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.06em"}}>Wallet Log / Usage</div>
          <button onClick={downloadCsv} disabled={walletLog.length === 0} style={{padding:"7px 14px",background:"transparent",color:walletLog.length===0?C.dim:C.blue,border:"1px solid "+(walletLog.length===0?C.border:C.blue),borderRadius:7,fontSize:11,fontWeight:700,cursor:walletLog.length===0?"not-allowed":"pointer",fontFamily:F}}>⤓ Download Excel</button>
        </div>
        {walletLog.length === 0 ? (
          <div style={{padding:20,textAlign:"center",background:C.light,borderRadius:10,color:C.muted,fontSize:12,border:"1px dashed "+C.border}}>No activity yet.</div>
        ) : (
          <div style={{border:"1px solid "+C.border,borderRadius:10,overflow:"hidden"}}>
            <div style={{display:"grid",gridTemplateColumns:"1.4fr 1fr 2.6fr 0.8fr",padding:"10px 14px",background:C.light,fontSize:10,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:"0.06em"}}>
              <div>Date</div><div>Employee</div><div>Description</div><div style={{textAlign:"right"}}>Amount</div>
            </div>
            {walletLog.map(r => (
              <div key={r.id} style={{display:"grid",gridTemplateColumns:"1.4fr 1fr 2.6fr 0.8fr",padding:"10px 14px",borderTop:"1px solid "+C.border,alignItems:"center",fontSize:12}}>
                <div style={{color:C.text}}>{new Date(r.created_at).toLocaleString("en-US",{month:"2-digit",day:"2-digit",year:"numeric",hour:"2-digit",minute:"2-digit",hour12:true})}</div>
                <div style={{color:C.text}}>{r.employee_name || "—"}</div>
                <div style={{color:C.text}}>{r.description}</div>
                <div style={{textAlign:"right",fontWeight:700,color:r.action_type==="deduct"?C.red:(r.action_type==="add"||r.action_type==="credit"?C.green:C.text)}}>
                  {r.action_type === "deduct" ? `${Math.abs(r.units_delta || 0)} Units` : (r.dollar_delta ? `$${Number(r.dollar_delta).toFixed(2)}` : `${r.units_delta || 0} unit(s)`)}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ── Add Modal ── */}
      {showAdd && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div style={{background:"#fff",borderRadius:14,width:"100%",maxWidth:480,padding:24,maxHeight:"92vh",overflowY:"auto"}}>
            <div style={{fontSize:16,fontWeight:800,color:C.gold,fontFamily:S,marginBottom:14}}>Add to Wallet — {client.name}</div>

            {/* Mode tabs */}
            <div style={{display:"flex",gap:4,marginBottom:16,padding:3,background:C.light,borderRadius:8}}>
              {[
                {k:"catalog", label:"📦 From Catalog"},
                {k:"custom",  label:"✨ Custom"},
                {k:"credit",  label:"💳 Credit"},
              ].map(m => (
                <button key={m.k} onClick={()=>setAddMode(m.k)} style={{flex:1,padding:"7px 8px",background:addMode===m.k?"#fff":"transparent",color:addMode===m.k?C.gold:C.muted,border:"none",borderRadius:6,fontSize:11,fontWeight:700,cursor:"pointer",fontFamily:F,boxShadow:addMode===m.k?"0 1px 3px rgba(0,0,0,0.06)":"none"}}>{m.label}</button>
              ))}
            </div>

            {addMode === "catalog" && (<>
              <div style={{marginBottom:12}}>
                <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>Select Package or Service</label>
                <select value={selectedPkg} onChange={e=>setSelectedPkg(e.target.value)} style={inp}>
                  <option value="">Choose...</option>
                  {packages.length > 0 && (
                    <optgroup label="Packages">
                      {packages.map(p => <option key={"pkg"+p.id} value={"pkg:"+p.id}>{p.name} — {p.sessions_total} unit(s) — ${p.price}</option>)}
                    </optgroup>
                  )}
                  {services.length > 0 && (
                    <optgroup label="Services">
                      {services.map(s => <option key={"svc"+s.id} value={"svc:"+s.id}>{s.name}{s.category?` · ${s.category}`:""} — ${Number(s.price||0).toFixed(0)}</option>)}
                    </optgroup>
                  )}
                </select>
              </div>
              {String(selectedPkg).startsWith("svc:") && (
                <div style={{marginBottom:12}}>
                  <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>Units / Sessions</label>
                  <input type="number" min={1} value={catalogUnits} onChange={e=>setCatalogUnits(Math.max(1,+e.target.value||1))} style={inp}/>
                  <div style={{fontSize:10,color:C.muted,marginTop:4,fontStyle:"italic"}}>How many units/sessions of this service to load into the wallet.</div>
                </div>
              )}
              <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                <button onClick={closeAdd} style={{padding:"9px 16px",background:C.light,color:C.muted,border:"1px solid "+C.border,borderRadius:7,fontSize:12,cursor:"pointer",fontFamily:F}}>Cancel</button>
                <button onClick={addFromCatalog} disabled={!selectedPkg} style={{padding:"9px 16px",background:!selectedPkg?C.light:"linear-gradient(135deg,"+C.gold+","+C.goldD+")",color:!selectedPkg?C.muted:"#fff",border:"none",borderRadius:7,fontSize:12,fontWeight:700,cursor:!selectedPkg?"not-allowed":"pointer",fontFamily:F}}>Add to Wallet</button>
              </div>
            </>)}

            {addMode === "custom" && (<>
              <div style={{marginBottom:10}}>
                <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>Item Name</label>
                <input value={customForm.item_name} onChange={e=>setCustomForm({...customForm,item_name:e.target.value})} placeholder="e.g. Erbium Yag Laser" style={inp}/>
              </div>
              <div style={{marginBottom:10}}>
                <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>Treatment Type (for auto-deduct)</label>
                <input value={customForm.treatment} onChange={e=>setCustomForm({...customForm,treatment:e.target.value})} placeholder="Matches appointment treatment" style={inp}/>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:8,marginBottom:14}}>
                <div>
                  <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>Units</label>
                  <input type="number" min={1} value={customForm.units} onChange={e=>setCustomForm({...customForm,units:+e.target.value})} style={inp}/>
                </div>
                <div>
                  <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>$ Per Unit</label>
                  <input type="number" step="0.01" value={customForm.unit_value} onChange={e=>setCustomForm({...customForm,unit_value:+e.target.value})} style={inp}/>
                </div>
                <div>
                  <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>Total $</label>
                  <input type="number" step="0.01" value={customForm.total_paid} onChange={e=>setCustomForm({...customForm,total_paid:+e.target.value})} style={inp}/>
                </div>
              </div>
              <div style={{fontSize:10,color:C.muted,marginBottom:14,fontStyle:"italic"}}>Tip: enter either "$ per unit" OR "Total $" — the other will be calculated.</div>
              <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                <button onClick={closeAdd} style={{padding:"9px 16px",background:C.light,color:C.muted,border:"1px solid "+C.border,borderRadius:7,fontSize:12,cursor:"pointer",fontFamily:F}}>Cancel</button>
                <button onClick={addCustom} disabled={!customForm.item_name || customForm.units < 1} style={{padding:"9px 16px",background:!customForm.item_name?C.light:"linear-gradient(135deg,"+C.gold+","+C.goldD+")",color:!customForm.item_name?C.muted:"#fff",border:"none",borderRadius:7,fontSize:12,fontWeight:700,cursor:!customForm.item_name?"not-allowed":"pointer",fontFamily:F}}>Add to Wallet</button>
              </div>
            </>)}

            {addMode === "credit" && (<>
              <div style={{marginBottom:10}}>
                <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>Credit Program</label>
                <select value={creditForm.item_name} onChange={e=>setCreditForm({...creditForm,item_name:e.target.value})} style={inp}>
                  <option value="Xperience Credit">Xperience Credit (Allergan)</option>
                  <option value="Aspire Credit">Aspire Credit (Galderma)</option>
                  <option value="Gift Card">Gift Card</option>
                  <option value="Promo Credit">Promo Credit</option>
                  <option value="Loyalty Credit">Loyalty Credit</option>
                </select>
              </div>
              <div style={{marginBottom:14}}>
                <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>$ Balance</label>
                <input type="number" step="0.01" min={0} value={creditForm.dollar_balance} onChange={e=>setCreditForm({...creditForm,dollar_balance:+e.target.value})} style={inp}/>
              </div>
              <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                <button onClick={closeAdd} style={{padding:"9px 16px",background:C.light,color:C.muted,border:"1px solid "+C.border,borderRadius:7,fontSize:12,cursor:"pointer",fontFamily:F}}>Cancel</button>
                <button onClick={addCredit} disabled={!creditForm.dollar_balance} style={{padding:"9px 16px",background:!creditForm.dollar_balance?C.light:"linear-gradient(135deg,"+C.gold+","+C.goldD+")",color:!creditForm.dollar_balance?C.muted:"#fff",border:"none",borderRadius:7,fontSize:12,fontWeight:700,cursor:!creditForm.dollar_balance?"not-allowed":"pointer",fontFamily:F}}>Add Credit</button>
              </div>
            </>)}
          </div>
        </div>
      )}

      {/* ── Edit Modal ── */}
      {editItem && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.5)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div style={{background:"#fff",borderRadius:14,width:"100%",maxWidth:420,padding:24}}>
            <div style={{fontSize:16,fontWeight:800,color:C.gold,fontFamily:S,marginBottom:5}}>Edit {editItem.package_name || editItem.treatment}</div>
            <div style={{fontSize:11,color:C.muted,marginBottom:14}}>Adjust the unit balance and/or dollar balance for this wallet item.</div>
            {!editItem.is_credit && (
              <div style={{marginBottom:10}}>
                <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>Balance Units</label>
                <div style={{display:"flex",alignItems:"center",gap:8}}>
                  <button onClick={()=>setEditUnits((+editItem.sessions_remaining||0)-1)} style={{minWidth:40,minHeight:40,background:"#fff",border:"1px solid "+C.border,borderRadius:8,cursor:"pointer",fontSize:20,color:C.muted,touchAction:"manipulation"}}>−</button>
                  <input type="number" min={0} value={editItem.sessions_remaining} onChange={e=>setEditUnits(e.target.value)} onFocus={e=>e.target.select()} style={{...inp,textAlign:"center",width:90}}/>
                  <button onClick={()=>setEditUnits((+editItem.sessions_remaining||0)+1)} style={{minWidth:40,minHeight:40,background:"#fff",border:"1px solid "+C.border,borderRadius:8,cursor:"pointer",fontSize:20,color:C.muted,touchAction:"manipulation"}}>+</button>
                </div>
                {+(editItem.unit_value||0) > 0 && (
                  <div style={{fontSize:11,color:C.muted,marginTop:6}}>
                    ${(+editItem.unit_value).toFixed(2)}/unit × {+editItem.sessions_remaining||0} = <strong style={{color:C.gold}}>${(((+editItem.unit_value)||0)*((+editItem.sessions_remaining)||0)).toFixed(2)}</strong> · value updates automatically
                  </div>
                )}
              </div>
            )}
            <div style={{marginBottom:14}}>
              <label style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",display:"block",marginBottom:5}}>$ Balance{!editItem.is_credit && +(editItem.unit_value||0) > 0 ? " (auto)" : ""}</label>
              <input type="number" step="0.01" min={0} value={editItem.dollar_balance} onChange={e=>setEditItem({...editItem,dollar_balance:+e.target.value})} style={inp}/>
            </div>
            <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
              <button onClick={()=>setEditItem(null)} style={{padding:"9px 16px",background:C.light,color:C.muted,border:"1px solid "+C.border,borderRadius:7,fontSize:12,cursor:"pointer",fontFamily:F}}>Cancel</button>
              <button onClick={saveEdit} style={{padding:"9px 16px",background:"linear-gradient(135deg,"+C.gold+","+C.goldD+")",color:"#fff",border:"none",borderRadius:7,fontSize:12,fontWeight:700,cursor:"pointer",fontFamily:F}}>Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ════════════════════════════════════════════════════════════════════
// addCartToWallet — call after a payment succeeds. Inserts one
// `patient_packages` row per cart item with units = item.qty so the
// services the client paid for show up in her wallet immediately.
//
// Cart shape (matches StripePayment + RecordPaymentModal):
//   [{ id?, name, price, qty }]
//
// Example: { name: "IV Therapy", price: 150, qty: 4 } → wallet item
// "IV Therapy" with 4 units / $600 balance / $150 unit_value.
//
// Caller passes paymentId so the wallet_log row can link back to the
// transaction. Returns { added: <number>, items: [<patient_package rows>] }.
// ════════════════════════════════════════════════════════════════════
export async function addCartToWallet(clientId, clientName, cart, opts = {}) {
  if (!clientId || !Array.isArray(cart) || cart.length === 0) {
    return { added: 0, items: [], errors: [] };
  }
  const { paymentId = null, paymentMethod = "card", userId = null, userName = "Staff" } = opts;
  const added = [];
  const errors = [];

  // ★ Dedup: the DB trigger `trg_auto_wallet` already auto-adds wallet items
  //   the moment a payment row is inserted (server-side, catches EVERY charge
  //   path). The trigger commits before this client-side call runs, so if items
  //   for this payment already exist, the trigger handled it — skip to avoid
  //   doubling the wallet. (Owner directive 2026-06-16: charges auto-fill wallet.)
  if (paymentId) {
    try {
      const { data: already } = await supabase
        .from("patient_packages")
        .select("id")
        .ilike("notes", `%payment #${paymentId}%`)
        .limit(1);
      if (already && already.length > 0) {
        return { added: already.length, items: [], errors: [], _viaTrigger: true };
      }
    } catch (_) { /* fall through and add normally */ }
  }

  const expiry = new Date();
  expiry.setDate(expiry.getDate() + 365);
  const expiryIso = expiry.toISOString();

  for (const item of cart) {
    const qty = Math.max(1, Number(item.qty || 1));
    const unitPrice = Number(item.price || 0);
    const total = +(qty * unitPrice).toFixed(2);
    const name = item.name || "Service";

    const { data: inserted, error: insErr } = await supabase
      .from("patient_packages")
      .insert([{
        client_id: clientId,
        client_name: clientName || "Client",
        package_name: name,
        treatment_type: name,
        total_sessions: qty,
        used_sessions: 0,
        price_paid: total,
        dollar_balance: total,
        unit_value: unitPrice,
        is_credit: false,
        expiry_date: expiryIso,
        status: "active",
        notes: paymentId ? `Auto-added from payment #${paymentId} (${paymentMethod})` : null,
      }])
      .select("id")
      .single();

    if (insErr) {
      console.error("[wallet] Failed to add item from cart:", name, insErr);
      errors.push(`${name}: ${insErr.message || JSON.stringify(insErr)}`);
      continue;
    }

    try {
      await supabase.from("wallet_log").insert([{
        client_id: clientId,
        client_name: clientName || "Client",
        patient_package_id: inserted?.id || null,
        action_type: "add",
        item_name: name,
        description: `Added Product - ${name} - ${qty} unit(s)` + (paymentId ? ` (payment #${paymentId})` : ""),
        units_delta: qty,
        dollar_delta: total,
        units_after: qty,
        dollar_after: total,
        employee_id: userId,
        employee_name: userName,
      }]);
    } catch (e) { console.warn("[wallet] log insert failed:", e); }

    added.push({ id: inserted?.id, name, qty, total });
  }
  // If every item failed, bubble that up as a single error message so the
  // caller can surface it in a useful alert.
  if (added.length === 0 && errors.length > 0) {
    return { added: 0, items: [], errors, _firstError: errors[0] };
  }
  return { added: added.length, items: added, errors };
}

// ════════════════════════════════════════════════════════════════════
// consumePackageSession — called when an appointment is completed.
// Picks the matching active wallet item (FIFO by expiry), decrements
// both the unit count AND the dollar balance (by unit_value), then
// writes a 'deduct' row to wallet_log so the AR-style log shows
// "Wallet Debits - <item>" for that date / employee.
// ════════════════════════════════════════════════════════════════════
export async function consumePackageSession(clientId, treatment, appointmentId, userId, userName) {
  if (!clientId || !treatment) return { used: false };

  // ★ Idempotency guard (2026-08-13): completion can fire more than once for
  //   the same appointment (re-complete, double-click, two open tabs). One
  //   appointment must NEVER consume two sessions — package_usage is the
  //   ledger, so if this appointment already has a usage row, we're done.
  if (appointmentId != null) {
    const { data: prior } = await supabase
      .from("package_usage")
      .select("id")
      .eq("appointment_id", appointmentId)
      .limit(1);
    if (prior?.length) return { used: false, alreadyConsumed: true };
  }

  // Fetch ALL active non-credit packages with sessions left (FIFO by expiry),
  // then match by name in code — normalized matching handles price prefixes
  // ("$129 Premium..."), promo suffixes ("... — $129 Special"), case/spacing,
  // and composite appointments ("Dermal Fillers + Daxxify"). Conservative by
  // design: no confident match → no deduction (same as the old exact match).
  const { data: pkgs } = await supabase
    .from("patient_packages")
    .select("*")
    .eq("client_id", clientId)
    .eq("status", "active")
    .eq("is_credit", false)
    .order("expiry_date", { ascending: true });
  const eligible = (pkgs || []).filter(p => (p.total_sessions - p.used_sessions) > 0);
  if (!eligible.length) return { used: false };
  const pkg = findPackageForTreatment(treatment, eligible);
  if (!pkg) return { used: false };

  const unitValue = Number(pkg.unit_value || 0);
  const newUsed = (pkg.used_sessions || 0) + 1;
  const newRemaining = Math.max(0, (pkg.total_sessions || 0) - newUsed);
  const newDollar = Math.max(0, Number(pkg.dollar_balance || 0) - unitValue);
  const newStatus = newRemaining === 0 ? "completed" : "active";

  await supabase.from("patient_packages").update({
    used_sessions: newUsed,
    dollar_balance: newDollar,
    status: newStatus,
  }).eq("id", pkg.id);

  // Legacy package_usage row (kept for backward compatibility with any
  // reports that already read from it).
  await supabase.from("package_usage").insert([{
    patient_package_id: pkg.id,
    appointment_id: appointmentId,
    client_id: clientId,
    treatment: treatment,
    used_by_user: userId,
    used_by_name: userName,
    sessions_remaining_after: newRemaining,
  }]);

  // New: AR-style wallet log entry. Shows up in ClientWallet's
  // "Wallet Log/Usage" panel with date + employee + description + amount.
  try {
    await supabase.from("wallet_log").insert([{
      client_id: clientId,
      patient_package_id: pkg.id,
      appointment_id: appointmentId,
      action_type: "deduct",
      item_name: pkg.package_name || treatment,
      description: `Wallet Debits - ${pkg.package_name || treatment}`,
      units_delta: -1,
      dollar_delta: -unitValue,
      units_after: newRemaining,
      dollar_after: newDollar,
      employee_id: userId || null,
      employee_name: userName || "System",
    }]);
  } catch (e) { console.warn("wallet_log deduct failed:", e); }

  // ★ Stamp the appointment as paid-via-package (2026-08-13): without this,
  //   every package visit shows up in reports as an uncollected appointment
  //   (that's how $44k of "unpaid" visits appeared in the revenue audit).
  //   package_usage/wallet_log keep the full audit trail of WHICH package.
  if (appointmentId != null) {
    try {
      await supabase.from("appointments").update({ paid: true }).eq("id", appointmentId);
    } catch (e) { console.warn("appointment paid-stamp failed:", e); }
  }

  return { used: true, package: pkg, remaining: newRemaining, dollar_remaining: newDollar };
}
